<div class="chart-container">
  <canvas #doughnutCanvas></canvas>
</div>